// libs
import React from 'react';
import { connect } from 'react-redux';

// selectors
import {
  getProductSizeOptions,
  getIsSizeGuideDataAvailable,
  isOneSize,
} from 'shared/store/details/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

// helpers
import { canShowPDPMeasurements } from './helpers';

//components
import SizeOptionsV2 from './SizeOptionsV2';

export interface ISizeOptionComponentProps {
  sizeOptions: ProductDetail.IProduct['sizeOptions'];
  isOneSize: boolean;
  canShowPDPMeasurements: boolean;
  isMobile: boolean;
  disabled?: boolean;
}

const mapStateToProps = (state: any) => ({
  sizeOptions: getProductSizeOptions(state),
  isOneSize: isOneSize(state),
  canShowPDPMeasurements: canShowPDPMeasurements(getRemoteConfig(state, 'showPDPMeasurement')),
  isNewSizeChartEnabled: getRemoteConfig(state, 'newSizeChartEnabled'),
  sizeGuideDataAvailable: getIsSizeGuideDataAvailable(state),
});

const SizeOptionsComponent = ({ isMobile = false, ...props }: ISizeOptionComponentProps) => (
  <SizeOptionsV2 isMobile={isMobile} {...props} />
);

export default connect(mapStateToProps)(SizeOptionsComponent);
